import getSubTreeWithId from "./getSubTreeWithId";

/**
 * Finds the IDs of all children nested under parentId in tree
 * @param {TreeRecord} tree
 * @param {string} parentId
 */
const getChildIdsOfParent = (tree, parentId) => {
  const subtree = getSubTreeWithId(tree, parentId);
  return subtree.children.map(c => c.id).toArray();
};

export default getChildIdsOfParent;
